export default {"src":"/_next/static/media/Stat_wine_left_2.d1db19bc.svg","height":164,"width":116,"blurWidth":0,"blurHeight":0};